import oc from "open-color";
import React, { ReactElement, useId, useState } from "react";
import { FaPencilAlt } from "react-icons/fa";
import t from "../../../helpers/i18n";
import CustomModal from "../../../components/CustomModal";

export interface MaintenanceDateProps {
  maintenanceDateStr: string;
  saveMaintenanceDate: (date: string) => Promise<void>;
}

export default function MaintenanceDate({
  maintenanceDateStr,
  saveMaintenanceDate,
}: MaintenanceDateProps): ReactElement {
  const [isModalOpened, setOpenedModal] = useState(false);
  const isMaintenanceToday = new Date() >= new Date(maintenanceDateStr);
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        gap: "5px",
        flexWrap: "wrap",
        marginBottom: "15px",
      }}
    >
      <div>{t("Maintenance date:", "Дата обслуговування:")}</div>
      <div style={{ display: "flex" }}>
        <div
          style={{
            color: isMaintenanceToday ? oc.orange[5] : oc.gray[8],
          }}
        >
          {maintenanceDateStr || "-"}
        </div>
        <button
          type="button"
          style={{
            border: "none",
            backgroundColor: "transparent",
            color: oc.blue[6],
            marginTop: "-8px",
          }}
          onClick={(e) => {
            e.preventDefault();
            setOpenedModal(true);
          }}
        >
          <FaPencilAlt size={15} />
        </button>
        <CustomModal
          title={t("Set maintenance date:", "Встановіть дату обслуговування:")}
          isOpen={isModalOpened}
          closeModal={() => setOpenedModal(false)}
        >
          <MaintenanceDateForm
            dateStr={maintenanceDateStr}
            saveMaintenceDate={saveMaintenanceDate}
            closeModal={() => setOpenedModal(false)}
          />
        </CustomModal>
      </div>
    </div>
  );
}

function MaintenanceDateForm({
  dateStr,
  saveMaintenceDate,
  closeModal,
}: {
  dateStr: string;
  saveMaintenceDate: (date: string) => Promise<void>;
  closeModal: () => void;
}): ReactElement {
  const [newDateStr, setNewDate] = useState(dateStr);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isError, setIsError] = useState(false);
  const inputId = useId();

  return (
    <form>
      <div className="form-group text-left">
        <label htmlFor={inputId} className="required">
          {t("Maintenance Date:", "Дата Обслуговування:")}
        </label>
        <input
          type="text"
          id={inputId}
          className={`${"form-control" + " " + (isError ? "is-invalid" : "")}`}
          value={newDateStr}
          required
          placeholder="2024-09-01"
          onChange={(e) => {
            setNewDate(e.target.value);
          }}
        />
        {isError && (
          <div className="invalid-feedback">
            Enter a correct format date, for example: 2024-09-01
          </div>
        )}
      </div>
      <div style={{ textAlign: "left" }}>
        <button
          type="button"
          className="btn btn-primary"
          disabled={isSubmitting}
          // eslint-disable-next-line @typescript-eslint/no-misused-promises
          onClick={async () => {
            setIsSubmitting(true);
            try {
              await saveMaintenceDate(newDateStr);
            } catch (err) {
              setIsError(true);
              setIsSubmitting(false);
              return;
            }
            setIsSubmitting(false);
            closeModal();
          }}
        >
          {t("Save", "Зберегти")}
        </button>
      </div>
    </form>
  );
}
